import {
  Avatar,
  Card,
  CardContent,
  Flex,
  Heading,
  Paragraph,
  Skeleton,
  Span,
} from "@ir/ui";

interface UserIdentity {
  fullName?: string;
  email?: string;
}

interface DetailedUserIdentity extends UserIdentity {
  authId?: string;
}

interface UserDetailsSummaryCardProps {
  userDetailsLoading: boolean;
  userDetails: DetailedUserIdentity | null;
  activebrandCount: number;
}

export const UserDetailsSummaryCard = ({
  userDetailsLoading,
  userDetails,
  activebrandCount,
}: Readonly<UserDetailsSummaryCardProps>) => {
  const isIdentityLoading = userDetailsLoading || !userDetails;

  return (
    <Card className="bg-white mb-4" variant="outlined" shadow>
      <CardContent>
        <Flex align="center" gap={0.8} justifyContent="space-between">
          <Flex align="center" gap={0.8}>
            {isIdentityLoading ? (
              <Skeleton width={56} height={56} variant="rounded-full" />
            ) : (
              <Avatar size="large" name={userDetails?.fullName ?? "User"} boxShadow />
            )}
            <Flex direction="column">
              <Flex direction="column">
                {isIdentityLoading ? (
                  <Skeleton width={300} height={18} variant="rounded" />
                ) : (
                  <Heading level={6} className="m-0 text-grey-700">
                    {userDetails?.fullName || "Unknown User"}
                  </Heading>
                )}
                {isIdentityLoading ? (
                  <Skeleton
                    width={260}
                    height={14}
                    variant="rounded"
                    className="mt-1"
                  />
                ) : (
                  <Paragraph className="m-0 text-grey-500">
                    {userDetails?.email || "No email available"}
                  </Paragraph>
                )}

                {isIdentityLoading ? (
                  <Skeleton
                    width={260}
                    height={14}
                    variant="rounded"
                    className="mt-1"
                  />
                ) : (
                  <Paragraph
                    className="m-0 text-grey-600 font-bold"
                    style={{ fontSize: "0.70rem" }}
                  >
                    {userDetails?.authId || "No auth id available"}
                  </Paragraph>
                )}
              </Flex>
            </Flex>
          </Flex>
          <Flex align="center" gap={1}>
            <Flex
              direction="column"
              align="center"
              className="border-color-grey-200 border-1 border-solid rounded-md p-2"
              style={{ borderRadius: "0.5rem" }}
            >
              <Flex className="text-primary font-bold display-md">
                {isIdentityLoading ? (
                  <Skeleton
                    width={80}
                    height={40}
                    variant="rounded"
                    className="mb-2"
                  />
                ) : (
                  <Span>{activebrandCount}</Span>
                )}
              </Flex>
              <Flex
                className="text-grey-400 font-medium"
                style={{
                  lineHeight: "1",
                  textTransform: "uppercase",
                  fontSize: "0.75rem",
                }}
              >
                Brand Access
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </CardContent>
    </Card>
  );
};
